import { PayloadAction, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { AuthApi } from "../../shared/api/AuthApi";
import { isUserLoggedIn } from "../../utility/Utils";

const initialUser = () => {
  const item = window.sessionStorage.getItem("userData");
  //** Parse stored json or if none return initialValue
  // return item ? JSON.parse(item) : {};
  return item;
};

const initialToken = () => {
  const item = window.sessionStorage.getItem("accessToken");
  //** Parse stored json or if none return initialValue
  return item ? item : "";
};

const updateLoggedInData = (data: any) => {
  sessionStorage.setItem("userData", JSON.stringify(data));
  sessionStorage.setItem("accessToken", data.jwtToken);
};

export interface AuthState {
  user: any;
  token: string;
  loading?: boolean;
  error?: string;
  isLoggedIn: boolean;
}

const initialState: AuthState = {
  user: initialUser(),
  token: initialToken(),
  loading: false,
  isLoggedIn: isUserLoggedIn(),
};

export const auth = createSlice({
  name: "auth",
  initialState,
  reducerPath: "auth",
  reducers: {
    updateToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    logout: (state) => {
      sessionStorage.removeItem("userData");
      sessionStorage.removeItem("accessToken");
      state.user = {};
      state.token = "";
      state.isLoggedIn = false;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(AuthApi.endpoints.authLogin.matchFulfilled),
      (state, action) => {
        updateLoggedInData(action.payload);
        state.loading = false;
        state.token = action.payload.accessToken;
        state.user = action.payload;
        state.isLoggedIn = true;
      }
    );
    builder.addMatcher(
      isAnyOf(AuthApi.endpoints.authLogin.matchPending),
      (state, action) => {
        state.loading = true;
        state.error = "";
      }
    );
    builder.addMatcher(
      isAnyOf(AuthApi.endpoints.authLogin.matchRejected),
      (state, action) => {
        state.loading = false;
      }
    );
  },
});

// Action creators are generated for each case reducer function
export const { updateToken, logout } = auth.actions;
// Other code such as selectors can use the imported `RootState` type
export const selectUser = (state: RootState) => state.auth.user;
export const selectToken = (state: RootState) => state.auth.token;
export const selectLoading = (state: RootState) => state.auth.loading;
export const isLoggedIn = (state: RootState) => state.auth.isLoggedIn;
